module.exports = __webpack_public_path__ + "static/media/studiouniversal.c2106c7e.png";